import React from 'react';
import { PlayCircleIcon, ClockIcon, YoutubeIcon, BookIcon, BookOpenIcon, UsersIcon, GlobeIcon, ArrowRightIcon } from 'lucide-react';
import { VideoCard } from './VideoCard';
import { Sidebar } from './Sidebar';
import { YouTubeCTA } from './YouTubeCTA';
const SAMPLE_VIDEOS = [{
  id: 1,
  title: 'Essential English Phrases for Beginners',
  titleAr: 'عبارات إنجليزية أساسية للمبتدئين',
  thumbnail: 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  duration: '10:25',
  category: 'Phrases'
}, {
  id: 2,
  title: 'Common Business English Vocabulary',
  titleAr: 'مفردات اللغة الإنجليزية التجارية الشائعة',
  thumbnail: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  duration: '15:30',
  category: 'Business'
}, {
  id: 3,
  title: 'Daily Conversation Practice',
  titleAr: 'ممارسة المحادثة اليومية',
  thumbnail: 'https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  duration: '12:15',
  category: 'Conversation'
}, {
  id: 4,
  title: 'Grammar Tips & Tricks',
  titleAr: 'نصائح وحيل القواعد',
  thumbnail: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  duration: '08:45',
  category: 'Grammar'
}];
export function VideoLibrary() {
  return <section className="w-full px-4 sm:px-6 md:px-10 lg:px-20 py-10 sm:py-12 md:py-16 bg-gray-50 dark:bg-gray-900/50" data-id="element-1609">
      <div className="max-w-7xl mx-auto" data-id="element-1610">
        {/* Header */}
        <div className="text-center mb-8 sm:mb-12" data-id="element-1611">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-3 sm:mb-4" data-id="element-1612">
            Educational Video Library
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 dark:text-gray-300 max-w-2xl mx-auto px-2" data-id="element-1613">
            Enhance your English learning journey with our carefully curated
            video lessons, designed specifically for Arabic speakers.
          </p>
        </div>
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8" data-id="element-1614">
          {/* Sidebar - Hidden on mobile, shown on desktop */}
          <div className="hidden lg:block lg:w-64" data-id="element-1615">
            <Sidebar data-id="element-1616" />
          </div>
          {/* Mobile Categories - Shown on mobile only */}
          <div className="lg:hidden mb-6 overflow-x-auto pb-2" data-id="element-1617">
            <div className="flex space-x-2 min-w-max px-2" data-id="element-1618">
              <button className="whitespace-nowrap px-3 py-1.5 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-full text-sm font-medium" data-id="element-1619">
                All Videos
              </button>
              <button className="whitespace-nowrap px-3 py-1.5 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-full text-sm font-medium" data-id="element-1620">
                Common Phrases
              </button>
              <button className="whitespace-nowrap px-3 py-1.5 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-full text-sm font-medium" data-id="element-1621">
                Business English
              </button>
              <button className="whitespace-nowrap px-3 py-1.5 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-full text-sm font-medium" data-id="element-1622">
                Conversation
              </button>
              <button className="whitespace-nowrap px-3 py-1.5 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-full text-sm font-medium" data-id="element-1623">
                Grammar
              </button>
            </div>
          </div>
          {/* Video Grid */}
          <div className="flex-1" data-id="element-1624">
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6 px-2 sm:px-0" data-id="element-1625">
              {SAMPLE_VIDEOS.map(video => <VideoCard key={video.id} {...video} data-id="element-1626" />)}
            </div>
            {/* YouTube CTA */}
            <div className="mt-10 sm:mt-16 px-2 sm:px-0" data-id="element-1627">
              <YouTubeCTA data-id="element-1628" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}